import React from 'react';
import { BtnModalTable } from '../../styled-components';

function GiveAndTakeLinkField({ value }) {
  if (!value) return <>-</>;

  return (
    <div style={{ textAlign: 'center' }}>
      <BtnModalTable type="button">
        <a href={value} target="_blank" rel="noopener noreferrer">
          Scarica Dettagli
        </a>
      </BtnModalTable>
    </div>
  );
}

export default GiveAndTakeLinkField;
